module.exports = __webpack_public_path__ + "img/equips.a835298f.svg";